/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GithubTemplateRepoEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('GITHUB_TEMPLATE_REPO_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class GithubTemplateRepoEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GithubTemplateRepoEnabledSettingParser.decode(input).map(res => new GithubTemplateRepoEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return GithubTemplateRepoEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GithubTemplateRepoEnabledSettingParser.encode(data);
    }
    static schema() {
        return GithubTemplateRepoEnabledSettingParser.schema();
    }
}
